import { ContentAssetKeys } from '@headless-workspace/core-domain';
import { InnerHTML, useClientData } from '@headless-workspace/domain/common/client';
import { GlowTextBodySmall, PropsWithFontFamily } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';

export const ProductDetailBuyNowPayLaterText: Component<PropsWithFontFamily> = ({ fontFamily }) => {
    const { getContentAssets } = useClientData();
    const paymentMethodsContent = getContentAssets(ContentAssetKeys.PaymentReinsurance);

    return (
        <GlowTextBodySmall
            fontFamily={fontFamily}
            data-testid="payment-method-info"
            innerHTML={<InnerHTML rawHtml={paymentMethodsContent?.content?.html} />}
        />
    );
};
